<template lang="pug">
div
  Query(
    :query="require('~/graphql/Highlight.gql').Highlights"
    :limit="2"
    :variables="{ type: 'MOMENT' , tags: tags }"
    v-slot="{ items }"
    :moreButton="false"
  )
    AsymetricGrid(:items="items" ref="grid" v-slot="{ item, ratio }")
      MomentCard(
        :slug="item.slug"
        :img="item.media.src"
        :ratio="ratio"
        :title="item.caption"
        :autoRatio="true"
        :likes="item.likes"
        @zoomin="onSelect(item)"
      )

  TheaterOverlay(
    :isActive="!!selectedItem.id"
    :title="selectedItem.caption"
    :image="selectedItem.media.src"
    @close="onLeave"
  )
    template(#buttons)
      .momentCard-overlay-like(@click="like")
        AppIcon(name="like")
        span {{ selectedItem.likes }}
</template>

<script>
import { LikeHighlight } from '~/graphql/Highlight.gql';
import AsymetricGrid from '~/components/PsudoRandomGrid';
import Query from '~/components/Query';
import MomentCard from '~/components/MomentCard';
import TheaterOverlay from '~/components/TheaterOverlay';

export default {
  name: 'MomentsTeam',
  props: {
    tags: {
      type: String,
      required: true
    }
  },
  components: {
    AsymetricGrid,
    Query,
    MomentCard,
    TheaterOverlay
  },
  data: () => ({
    highlights: {},
    selectedItem: {
      likes: 0,
      id: null,
      caption: '',
      media: { src: '' }
    }
  }),

  async created() {
    let params = {};
    params.slug = 'happy-coding';
  },

  methods: {
    onLeave() {
      this.selectedItem = {
        likes: 0,
        id: null,
        caption: '',
        media: { src: '' }
      };
      // this.$router.localePush('/moments');
    },
    async like() {
      try {
        this.selectedItem.likes++;
        const { data } = await this.$api.mutate({
          mutation: LikeHighlight,
          variables: {
            id: this.selectedItem.id
          }
        });

        return data;
      } catch (err) {
        console.error(err);
      }
    },
    onSelect(item) {
      this.selectedItem = item;
      // this.$router.localePush(`/moments/${item.slug}`);
    }
  }
};
</script>
